import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingChat from "./FloatingChat";
import { Toaster } from "./ui/sonner";
import { apiClient } from "../lib/api";

export const Layout = () => {
  const location = useLocation();
  const lastTracked = useRef("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // Track visit (best-effort, fire-and-forget)
    if (lastTracked.current !== location.pathname) {
      lastTracked.current = location.pathname;
      apiClient
        .post("/track-visit", {
          path: location.pathname,
          referrer: document.referrer || "",
          user_agent: navigator.userAgent || "",
        })
        .catch(() => {});
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-neutral-100 flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16 sm:pt-20">
        <Outlet />
      </main>
      <Footer />
      <FloatingChat />
      <Toaster theme="dark" richColors position="top-right" />
    </div>
  );
};

export default Layout;
